import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    refresh: false,
    confirmation: false,
    employeeDetails:{},
    changeManagementModuleConfig:{},
}

export const employeeConfirmationTableRefreshSlice = createSlice({
    name: 'employee/employeeConfirmationTableRefresh',
    initialState,
    reducers: {
        setRefresh: (state, action) => {
            return { ...state, ...action.payload };
        },
        setConfirmation: (state, action) => {
            state.confirmation=action.payload;
        },
        setEmployeeDetails:(state, action)=>{
            return { ...state, ...action.payload };
        },
        setChangeManagementModuleConfig:(state, action)=>{
          state.changeManagementModuleConfig = action.payload ;
        },
    }
})

export const { setRefresh,setConfirmation,setEmployeeDetails, setChangeManagementModuleConfig } = employeeConfirmationTableRefreshSlice.actions;
export default employeeConfirmationTableRefreshSlice.reducer